class VariantPLPSection {

    swap( value, productid, event){
      //document.
      const variantData = JSON.parse(document.getElementById('product-application-'+productid).textContent);
      const colorlebeldata = Array.from(event.parentElement.querySelectorAll('label'));
      colorlebeldata.map((colorlebelfieldset) => {
        colorlebelfieldset.classList.remove('current-active');
      });
      event.classList.add('current-active');
      
      event.parentElement.querySelector(".form__label span").innerHTML = event.dataset.value;
      const colorindex = event.parentElement.dataset.optionIndex;
      const listSizeelement = document.querySelector('.list-size[data-product-id="'+productid+'"]');
      const listSizedata = Array.from(listSizeelement.querySelectorAll('label'));
      listSizedata.map((sizelebelfieldset) => {
        sizelebelfieldset.remove();
      });
      const sizeindex = document.querySelector('.list-size[data-product-id="'+productid+'"]').dataset.optionIndex;
      var selectedvariant = '';
      variantData.find((variant) => {
        if( variant[colorindex] == value ){
          //console.log(variant.id)
          if( selectedvariant == '' ) selectedvariant = variant
          var label = document.createElement("label");
          label.innerHTML = this.sizeLabel(variant[sizeindex]);
          if(!variant.available){
            label.classList.add('soldout');
          }else{
            if(event.parentElement.parentElement.classList.contains('featured-product-sec')){
              label.setAttribute("onclick","classVariantPLPSection.changeVarId(this, "+variant.id+");");
              
            }else{
              label.setAttribute("onclick","classVariantPLPSection.addtocart("+variant.id+");");
            }
          }
          listSizeelement.appendChild(label);
        }
      });
      if(event.parentElement.parentElement.classList.contains('featured-product-sec')){
        var total = event.parentElement.parentElement.querySelector(".list-size").querySelectorAll("label").length;
        var total_soldout = event.parentElement.parentElement.querySelector(".list-size").querySelectorAll(".soldout").length;
        if(total_soldout == total){
          event.parentElement.closest(".jg-pdt-feature-cont").querySelector(".product-form-group").querySelector("form").querySelector(".product-form__buttons").querySelector(".feature-pro-submit-btn").classList.add("disabled");
          event.parentElement.closest(".jg-pdt-feature-cont").querySelector(".product-form-group").querySelector("form").querySelector(".product-form__buttons").querySelector(".feature-pro-submit-btn span").innerHTML = "Soldout";
        }else{
          event.parentElement.closest(".jg-pdt-feature-cont").querySelector(".product-form-group").querySelector("form").querySelector(".product-form__buttons .feature-pro-submit-btn").classList.remove("disabled");
          event.parentElement.closest(".jg-pdt-feature-cont").querySelector(".product-form-group").querySelector("form").querySelector(".product-form__buttons .feature-pro-submit-btn span").innerHTML = "Add to cart";
        }
      console.log(total, total_soldout);
      }
      if( selectedvariant != '' ){
        if(event.parentElement.parentElement.classList.contains('featured-product-sec')){
          event.closest(".jg-pdt-feature-cont").querySelector(".product-form-group").querySelector(".product-form").querySelector("input[name='id']").value = selectedvariant.id;
            var selectedvariants = selectedvariant.id.toString();
            var leftsideimage = document.querySelectorAll(".jg-pdt-f-left");
            var rightsideimage = document.querySelectorAll(".jg-pdt-f-right");
            var jgpdpsliderlisting = document.getElementById("jg-pdp-slider-listing");
            var jgselectedelements = jgpdpsliderlisting.getElementsByClassName('jg-pdt-slide');
            var jj = 0;
            
            for (var i = 0; i < jgselectedelements.length; i++) {
            var datavariants = jgselectedelements.item(i).getAttribute('data-variants');
            var splitvariants = datavariants.split(",");

            if(splitvariants.includes(selectedvariants)){
              if( jj == 0 ){
                leftsideimage.forEach(imgdiv => {
                  imgdiv.innerHTML = '';
                  imgdiv.append(jgselectedelements.item(i).cloneNode(true));
                });
              }else if( jj == 1 ){
                rightsideimage.forEach(imgrtdiv => {
                  imgrtdiv.innerHTML = '';
                  imgrtdiv.append(jgselectedelements.item(i).cloneNode(true));
                });
              }
              jj++;
            }
          }
        }
        this.imageswatch( selectedvariant.id, productid)
      }
    }
  
    sizeLabel(text){
      var selectedtext = text;
      if( text == 'x-small' || text == 'X-small' ){
        selectedtext = "XS";
      }else if( text == 'small' || text == 'Small' ){
        selectedtext = "S";
      }else if( text == 'medium' || text == 'Medium' ){
        selectedtext = "M";
      }else if( text == 'large' || text == 'Large' ){
        selectedtext = "L";
      }else if( text == 'x-large' || text == 'X-large' ){
        selectedtext = "XL";
      }else if( text == 'xx-large' || text == 'X-large' ){
        selectedtext = "XXL";
      }
      return selectedtext;
    }
  
    sliderPrev( productid, event){
      const productSliderElement = document.getElementById('productSliderId-'+productid);
      const currentElement = productSliderElement.querySelector('.slider-item-main .s-item-current');
      if( currentElement.previousElementSibling ){
        currentElement.classList.remove('s-item-current');
        currentElement.previousElementSibling.classList.add('s-item-current');
      }else{
        currentElement.classList.remove('s-item-current');
        productSliderElement.querySelector('.slider-item-main .slider-item:last-child').classList.add('s-item-current');
      }
    }
  
    sliderNext( productid, event){
      const productSliderElement = document.getElementById('productSliderId-'+productid);
      const currentElement = productSliderElement.querySelector('.slider-item-main .s-item-current');
      if( currentElement.nextElementSibling ){
        currentElement.classList.remove('s-item-current');
        currentElement.nextElementSibling.classList.add('s-item-current');
      }else{
        currentElement.classList.remove('s-item-current');
        productSliderElement.querySelector('.slider-item-main .slider-item:first-child').classList.add('s-item-current');
      }
    }
  
    imageswatch(variantid,productid){
      const productSlider = document.getElementById("productSliderId-"+productid);
      const productmainimageListing = document.getElementById("products-slider-listing-"+productid);
      const selectedelements = productmainimageListing.getElementsByClassName('slider-item');
      const slideritemmain = productSlider.querySelector('.slider-item-main');
      this.empty(slideritemmain);
      var flag = true;
      for (var i = 0; i < selectedelements.length; i++) {
        var datavariants = selectedelements.item(i).getAttribute('data-variants');
        const splitvariants = datavariants.split(",");
        if( splitvariants.map(str => Number(str)).includes(variantid) ){
          var dupeelemnt = selectedelements.item(i).cloneNode(true);
          if(flag){
            dupeelemnt.classList.add('s-item-current');
            flag = false;
          }
          slideritemmain.append(dupeelemnt);
        }
      }
    }
  
    empty(element) {
      while(element.firstElementChild) {
         element.firstElementChild.remove();
      }
    }

    changeVarId(eve,id){
      eve.parentNode.querySelectorAll("label").forEach(lbl => {
        if(lbl.classList.contains("current-active")){
          lbl.classList.remove("current-active");
        }
      });
      eve.classList.add("current-active");
      eve.closest(".jg-pdt-feature-cont").querySelector(".product-form-group").querySelector(".product-form").querySelector("input[name='id']").value = id;
      eve.parentNode.querySelector(".form__label span").innerHTML = eve.innerHTML;
    }
  
    addtocart( variantid ){
      //var addtocartdata = this.addVariantToCart(variantid);
      var cart = document.querySelector('cart-drawer');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantid,
          quantity: 1,
          sections: cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        })
      }).then((response) => response.json()).then(function (response) {
        if (response.status) {
         
        }else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        cart.renderContents(response);
      }).catch(function (error) {
        console.log(error);
      }).finally(() => {
        if (cart && cart.classList.contains('is-empty')){
         cart.classList.remove('is-empty');
        }
        $("#cart-icon-bubble").click();
        /*
        cart.classList.add("active");
        document.body.classList.add('mini-cart-open');*/
      });
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer'
            },
            {
                id: 'cart-icon-bubble'
            }
        ];
    }
}

var classVariantPLPSection = new VariantPLPSection();